<template>
  <div>
    <el-dialog
      class="modal"
      title="刪除角色"
      :visible.sync="delModal"
      width="375px"
    >
      確認刪除 {{ currentData.name }} ?
      <el-input v-model="oneCode" placeholder="驗證碼"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="delModal = false" class="btn">取消</div>
        <div @click="confirmDel" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯角色"
      :visible.sync="editModal"
      width="375px"
    >
      <el-input v-model="currentData.name" placeholder="角色名稱"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editModal = false" class="btn">取消</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="新增角色"
      :visible.sync="addModal"
      width="375px"
    >
      <el-input v-model="name" placeholder="角色名稱"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">取消</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <div v-if="!authList">
      <el-button
        type="primary"
        size="mini"
        @click="
          addModal = true;
          name = '';
        "
        >新增角色</el-button
      >
      <el-table
        stripe
        :data="dataList"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          :min-width="100"
          header-align="center"
          align="center"
          prop="name"
          label="角色名稱"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          header-align="center"
          align="center"
          prop="created_at"
          label="創建時間"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          header-align="center"
          align="center"
          prop="updated_at"
          label="更新時間"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          header-align="center"
          align="center"
          prop="name"
          label="操作"
          v-if="$permission('settings.roles.update')"
        >
          <template slot-scope="scope">
            <div>
              <el-button
                v-if="scope.row.update"
                size="mini"
                @click="editData(scope.row)"
                >編輯</el-button
              >
              <el-button
                v-if="scope.row.update"
                size="mini"
                @click="delData(scope.row)"
                >刪除</el-button
              >
              <el-button size="mini" @click="editAuth(scope.row)"
                >權限</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="authList">
      <div class="labelGroup" v-for="(data, index) in authList" :key="index">
        <div class="checkbox c-checkbox">
          <label>
            <input
              @change="allClick(data)"
              type="checkbox"
              value
              :checked="secondCheck(data)"
            />
            <!-- <span class="fa fa-check"></span> -->
            {{ data[Object.keys(data)[0]] }}
          </label>
        </div>
        <div
          class="labelChildren"
          v-for="(second, index) in data.sub"
          :key="index"
        >
          <div class="checkbox c-checkbox">
            <label>
              <input
                @change="allClick(second)"
                type="checkbox"
                value
                :checked="secondCheck(second)"
              />
              <!-- <span class="fa fa-check"></span> -->
              {{ second.name }}
            </label>
          </div>
          <div class="children">
            <div
              class="checkbox c-checkbox lastBox"
              v-for="(children, num) in second"
              :key="num"
              v-show="children != second.name"
            >
              <label>
                <input type="checkbox" v-model="children.check" value />
                <!-- <span class="fa fa-check"></span> -->
                {{ children[Object.keys(children)[0]] }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="btnGroup">
        <el-button
          style="margin-bottom:5px"
          size="mini"
          @click="authList = false"
          >上一步</el-button
        >
        <el-button
          type="primary"
          style="margin-bottom:5px"
          size="mini"
          @click="confirmEditAuth"
          >確認</el-button
        >
        <!-- @click="checkEditAuth" -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [],
      name: "",
      addModal: false,
      currentData: {},
      editModal: false,
      delModal: false,
      oneCode: "",
      authList: false
    };
  },
  methods: {
    confirmEditAuth() {
      let sendData = [];
      let data = this.authList;
      Object.keys(data).forEach(e => {
        Object.keys(data[e].sub).forEach(two => {
          Object.keys(data[e].sub[two]).forEach(thr => {
            if (thr == "name") return;
            if (data[e].sub[two][thr].check) {
              sendData.push(Object.keys(data[e].sub[two][thr])[0]);
            }
          });
        });
      });
      this.$http
        .post(`/back/roles/sync`, {
          permissions: sendData,
          role_id: this.currentData.id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.authList = false;
            this.$message.success("成功");
          }
        });
    },
    editAuth(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.$http.get(`/back/roles/${data.id}`).then(res => {
        if (res.data.code == 0) {
          this.authList = res.data.data.permissions;
        }
      });
    },
    secondCheck(data) {
      let method = false;
      if (data.sub) {
        Object.keys(data.sub).forEach(one => {
          Object.keys(data.sub[one]).forEach(datas => {
            if (datas != "name") {
              if (data.sub[one][datas].check) {
                method = true;
              }
            }
          });
        });
      } else {
        Object.keys(data).forEach(datas => {
          if (datas != "name") {
            if (data[datas].check) {
              method = true;
            }
          }
        });
      }
      return method;
    },
    allClick(data) {
      if (data.sub) {
        Object.keys(data.sub).forEach(e => {
          Object.keys(data.sub[e]).forEach(datas => {
            if (datas != "name") {
              data.sub[e][datas].check = event.target.checked;
            }
          });
        });
      } else {
        Object.keys(data).forEach(datas => {
          if (datas != "name") {
            data[datas].check = event.target.checked;
          }
        });
      }
    },
    confirmDel() {
      this.$http
        .delete(`/back/roles/${this.currentData.id}`, {
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.delModal = false;
            this.$message.success("成功");
          }
        });
    },
    delData(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.delModal = true;
      this.oneCpde = "";
    },
    confirmEdit() {
      this.$http
        .put(`/back/roles/${this.currentData.id}`, {
          name: this.currentData.name
        })
        .then(res => {
          if (res.data.code == 0) {
            this.editModal = false;
            this.getData();
            this.$message.success("成功");
          }
        });
    },
    editData(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.editModal = true;
    },
    confirmAdd() {
      this.$http
        .post(`/back/roles`, {
          name: this.name
        })
        .then(res => {
          if (res.data.code == 0) {
            this.addModal = false;
            this.getData();
          }
        });
    },
    getData() {
      this.$http.get(`/back/roles`).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.labelGroup {
  margin-top: 30px;
}
.labelChildren {
  margin-left: 20px;
  margin-top: 10px;
  .children {
    margin-top: 10px;
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    .lastBox {
      margin: 5px;
    }
  }
}
h2 {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 26px;
  em {
    font-size: 48px;
    color: white;
    margin-right: 20px;
  }
}
.btnGroup {
  display: flex;
  justify-content: center;
}
</style>
